import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMastercard = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 16,
	viewBox: "0 0 24 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_15527_699)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M11.4764 5.56629L10.4924 10.446H9.30237L10.2864 5.56629H11.4764ZM16.4938 8.71725L17.1231 6.8843L17.4835 8.71725H16.4938ZM17.8211 10.446H18.9253L17.9641 5.56629H16.9458C16.7169 5.56629 16.5224 5.70729 16.4366 5.92185L14.6516 10.446H15.9045L16.1562 9.71648H17.6838L17.8211 10.446ZM14.7088 8.85825C14.7145 7.57089 13.0268 7.49733 13.0382 6.92108C13.044 6.7433 13.1984 6.5594 13.5417 6.51035C13.7133 6.48583 14.1825 6.46744 14.7145 6.73104L14.9262 5.69503C14.6402 5.58468 14.2683 5.48047 13.8106 5.48047C12.6321 5.48047 11.8025 6.14254 11.7968 7.09273C11.791 7.79771 12.3918 8.19005 12.838 8.423C13.3014 8.66208 13.4616 8.81533 13.4559 9.02989C13.4559 9.3548 13.084 9.50192 12.7465 9.50805C12.1458 9.52032 11.7968 9.33641 11.5222 9.20154L11.3048 10.2682C11.5851 10.4031 12.1 10.5195 12.6321 10.5257C13.8907 10.5318 14.7088 9.87587 14.7088 8.85825ZM9.77722 5.57242L7.84349 10.4521H6.58485L5.63515 6.5594C5.57794 6.32032 5.52645 6.23449 5.35482 6.13028C5.06304 5.96476 4.58819 5.8115 4.17627 5.71342L4.20487 5.57242H6.23014C6.48759 5.57242 6.72216 5.75633 6.77937 6.06897L7.28282 8.89503L8.5243 5.57242H9.77722Z",
				fill: "white"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M0.45752 1.72848C0.45752 0.956071 1.04107 0.336914 1.75621 0.336914H22.2492C22.97 0.336914 23.5479 0.962201 23.5479 1.72848V14.2649C23.5479 15.0373 22.9643 15.6565 22.2492 15.6565H1.75621C1.03535 15.6565 0.45752 15.0312 0.45752 14.2649V1.72848Z",
				fill: "#3C404B"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12.8092 7.85277C12.8092 9.73476 11.3561 11.2612 9.55964 11.2612C7.76322 11.2612 6.31006 9.73476 6.31006 7.85277C6.31006 5.97077 7.76322 4.44434 9.55964 4.44434C11.3561 4.44434 12.8092 5.97077 12.8092 7.85277Z",
				fill: "#F26436"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.6837 7.85277C17.6837 9.73476 16.2306 11.2612 14.4342 11.2612C12.6377 11.2612 11.1846 9.73476 11.1846 7.85277C11.1846 5.97077 12.6377 4.44434 14.4342 4.44434C16.2306 4.44434 17.6837 5.97077 17.6837 7.85277Z",
				fill: "#FFC735"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_15527_699",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 16,
			fill: "white"
		})
	}) })]
});
export default SvgMastercard;
